<script setup>

</script>

<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.75 13.2916C26.7549 15.1615 26.318 17.006 25.475 18.675C24.4754 20.675 22.9388 22.3571 21.0372 23.5331C19.1356 24.7091 16.9442 25.3324 14.7083 25.3333C12.8385 25.3382 10.994 24.9013 9.325 24.0583L1.25 26.75L3.94167 18.675C3.09865 17.006 2.66179 15.1615 2.66667 13.2916C2.66753 11.0558 3.29087 8.86435 4.46685 6.96276C5.64284 5.06117 7.32503 3.52453 9.325 2.52498C10.994 1.68197 12.8385 1.2451 14.7083 1.24998H15.4167C18.3695 1.41288 21.1585 2.65922 23.2496 4.75036C25.3408 6.8415 26.5871 9.63049 26.75 12.5833V13.2916Z"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>